
<template>
    
    <div>
        
        <div class="video-content pAbsolute" style="width: 320px; height: 180px">
            <div class="player_wrap h100" id="youtubePlayer"></div>

            <!-- <div class="plyr__video-embed" id="player">
                <iframe
                    src="https://www.youtube.com/embed/szlTFHWf3Z4?feature=share"
                ></iframe>
            </div> -->
            <!-- <iframe id="player" type="text/html" width="640" height="360"
            src="http://www.youtube.com/embed/qYXAc73vkYY?enablejsapi=1&origin=http://example.com"
            frameborder="0"></iframe> -->
        </div>
    </div>
</template>

<script>

export default {
    name: "playerTest",
    mixins: [],
    components: {
        
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {

    },
    data() {
        return{
            videoId: '',

        }
    },
    beforeRouterEnter() {
        
    },
    created() {
        // var tag = document.createElement('script');
        // tag.id = 'youtubePlayer';
        // tag.src = "https://www.youtube.com/iframe_api";
        // var firstScriptTag = document.getElementsByTagName('script')[0];
        // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
        
        
    },
    mounted() {
        if(!document.getElementById('youtubeIFrameApi')) {
                var tag = document.createElement('script');
                tag.id = 'youtubeIFrameApi';
                tag.src = 'https://www.youtube.com/iframe_api';
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                // document.head.appendChild(tag);
            }
        this.getVideo();
        

    },
    beforeDestroy() {

    },
    destroyed() {},
    computed: {
    },
    methods:{
        getVideo() {
            console.log("11");
            window.YT.ready(function() {
                this.youtubePlayer = new YT.Player('youtubePlayer', {
                height: 180,
                width: 320,
                videoId: 'qYXAc73vkYY',
                // events: {
                //     'onReady': this.onPlayerReady(),
                //     'onStateChange': this.onPlayerStateChange()
                // }
            });
            });
            
            
        },

        onPlayerReady(event) {
            // console.log(event)
        },
        onPlayerStateChange(event) {
            // slide47
            if (!this.status && event.data === YT.PlayerState.PLAYING) {
                this.status = true;

                logEvent('video_play', {
                    title: event.target.playerInfo.videoData.title,
                    author: event.target.playerInfo.videoData.author
                });
            }
        },
        },
    
    watch: {

    },

}
</script>

<style scoped>

</style>
